<template>
    <div class="ripple-container">
        <div class="wave-wrapper">
            <div class="center-dot"></div>
            <div v-if="isAnimating" class="wave"></div>
            <div v-if="isAnimating" class="wave"></div>
            <div v-if="isAnimating" class="wave"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RippleAnimation',
    props: {
        isAnimating: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
.ripple-container {
    width: 100%;
    height: 100%;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.wave-wrapper {
    position: relative;
    width: 100%;
    max-width: 600px;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.wave {
    position: absolute;
    width: 20px;
    height: 20px;
    border: 8px solid;
    border-radius: 50%;
    animation: ripple 3s infinite;
}

.wave:nth-child(2) {
    animation-delay: 1s;
}

.wave:nth-child(3) {
    animation-delay: 2s;
}

@keyframes ripple {
    0% {
        width: 20px;
        height: 20px;
        opacity: 1;
        border-width: 8px;
        border-color: rgba(255, 166, 3, 0.8);
    }
    25% {
        border-color: rgba(255, 200, 50, 0.7);
    }
    50% {
        border-width: 4px;
        border-color: rgba(128, 227, 128, 0.6);
    }
    75% {
        border-color: rgba(51, 242, 210, 0.4);
    }
    100% {
        width: 500px;
        height: 500px;
        opacity: 0;
        border-width: 1px;
        border-color: rgba(3, 255, 253, 0.2);
    }
}

.center-dot {
    position: absolute;
    width: 5em;
    height: 5em;
    background: #FFA603;
    border-radius: 50%;
    box-shadow: 0 0 20px rgba(255, 166, 3, 0.6);
    z-index: 10;
}

@media (max-width: 768px) {
    .wave-wrapper {
        max-width: 90vw;
        height: 90vw;
    }

    @keyframes ripple {
        0% {
            width: 20px;
            height: 20px;
            opacity: 1;
            border-width: 8px;
            border-color: rgba(255, 166, 3, 0.8);
        }
        25% {
            border-color: rgba(255, 200, 50, 0.7);
        }
        50% {
            border-width: 4px;
            border-color: rgba(128, 227, 128, 0.6);
        }
        75% {
            border-color: rgba(51, 242, 210, 0.4);
        }
        100% {
            width: 80vw;
            height: 80vw;
            opacity: 0;
            border-width: 1px;
            border-color: rgba(3, 255, 253, 0.2);
        }
    }
}
</style>